import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, House } from "@phosphor-icons/react";
import { BottomNav } from "@/components/BottomNav";
import { Logo } from "@/components/Logo";
import { HeaderCredits } from "@/components/HeaderCredits";
import { WhatsNew } from "@/components/WhatsNew";
import { Footer } from "@/components/Footer";
import { GuestBanner } from "@/components/GuestBanner";

export function Shell({ children, showNav = true, header = true, home = false, back, wide = false }) {
  const navigate = useNavigate();
  const goBack = () => { if (window.history.length > 1) window.history.back(); else navigate("/dashboard"); };

  return (
    <div className={`mx-auto ${wide ? "max-w-md lg:max-w-5xl" : "max-w-md"} h-[100dvh] relative overflow-hidden text-gray-800 sm:border-x-2 sm:border-gray-800 flex flex-col sb-appbg`} style={{ background: "var(--app-bg)" }}>
      <div className="sb-blob sb-float" style={{ width: 160, height: 160, top: -40, right: -40, background: "var(--app-primary)" }} />
      <div className="sb-blob sb-float" style={{ width: 120, height: 120, bottom: 80, left: -50, background: "var(--app-border)", animationDelay: "2s" }} />
      {header && (
        <div className="flex items-center pt-5 pb-2 px-4 shrink-0 relative z-10">
          {!home ? (
            <div className="flex items-center gap-2 shrink-0">
              <button data-testid="header-back" onClick={goBack} aria-label="Zurück"
                className="w-12 h-12 rounded-2xl border-2 border-gray-800 bg-white flex items-center justify-center active:scale-90 transition-transform shadow-[2px_2px_0_0_rgba(31,41,55,1)]">
                <ArrowLeft size={24} weight="bold" className="text-gray-800" />
              </button>
              <button data-testid="header-home" onClick={() => navigate("/dashboard")} aria-label="Startseite"
                className="w-12 h-12 rounded-2xl border-2 border-gray-800 bg-white flex items-center justify-center active:scale-90 transition-transform shadow-[2px_2px_0_0_rgba(31,41,55,1)]">
                <House size={24} weight="bold" className="text-gray-800" />
              </button>
            </div>
          ) : <div className="w-[104px] shrink-0" />}
          <div className="flex-1 flex justify-center">
            <Logo className="h-7" />
          </div>
          <div className="w-[104px] shrink-0 flex justify-end items-center">
            <HeaderCredits />
          </div>
        </div>
      )}
      <div className="flex-1 overflow-y-auto scrollbar-hide px-5 pt-2 pb-28 relative z-10">
        <GuestBanner />
        {children}
        <Footer />
      </div>
      {showNav && <BottomNav />}
      <WhatsNew />
    </div>
  );
}
